import { render, staticRenderFns } from "./ChannelSummary.vue?vue&type=template&id=b23af32a&"
import script from "./ChannelSummary.vue?vue&type=script&lang=js&"
export * from "./ChannelSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports